module.exports = __webpack_public_path__ + "img/hours.6c423f74.svg";